<ng-container>
  <div class="lead">
    <p>
      REGLAS Generales y criterios para la integración y operación del Sistema
      Nacional de Competencias. Artículo 83. El CONOCER diseñará, organizará y
      operará el Registro Nacional de Personas con Competencias Certificadas de
      manera independiente o conjunta con otras instancias de los niveles de
      gobierno Federal, Estatal y/o Municipal, según lo defina el propio
      CONOCER.
    </p>

    <p>
      El Registro Nacional de Personas con Competencias Certificadas, podrá ser
      consultado por todo el público en general de manera gratuita, y tendrá
      como objetivo fundamental integrar una base de datos con información sobre
      las personas que han obtenido uno o más Certificados de Competencia, con
      base en Estándares de Competencia inscritos en el Registro Nacional de
      Estándares de Competencia.
    </p>
    <p>
      Además, este Registro podrá servir para que las personas con competencias
      certificadas, puedan voluntariamente ingresar sus datos personales, para
      facilitar su localización, en caso de que organizaciones sindicales,
      empresas, sector académico, sector social o público, o alguna otra
      institución pública o privada, requieran personal con competencias
      certificadas en determinada Función Individual.
    </p>

    <p>
      Los datos personales recabados serán protegidos y serán incorporados y
      tratados en el Sistema de datos personales del RENAP con fundamento en las
      reglas generales y criterios para integración y operación del Sistema
      Nacional de Competencias y cuya finalidad es integrar una base de datos
      con información sobre las personas que han obtenido uno o más Certificados
      de Competencia, con base en Estándares de Competencia inscritos en el
      Registro Nacional de Estándares de Competencia, el cual fue registrado en
      el Listado de sistemas de Datos Personales ante el Instituto Federal de
      Acceso a la información Pública (www.ifai.org.mx) y podrán ser trasmitidos
      a sujetos obligados o dependencias y entidades con la finalidad del uso en
      facultades propias de las mismas. Además de otras trasmisiones previstas
      en Ley. La Unidad Administrativa responsable del Sistema es el Consejo
      Nacional de Normalización y Certificación de Competencias Laborales y la
      dirección donde el usuario podrá ejercer los derechos de acceso y
      corrección ante la misma es Av. Barranca del Muerto 275 Col. San José
      Insurgentes CP. 03900, México D.F. Lo anterior se informa en cumplimiento
      del Decimoséptimo de los lineamientos de protección de Datos Personales,
      publicados en el Diario Oficial de la Federación el 30 de septiembre de
      2005.
    </p>

    <p></p>
  </div>

  <div class="panel">
    <div class="row">
      <div class="container">
        <div class="col-sm-1"></div>
        <div class="col-sm-10 leyenda1">
          <p>Registro Nacional de personas con competencias certificadas</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="container">
        <p class="p_text">
          En el Registro Nacional de Personas con Competencias Certificadas se
          encuentran todas aquellas personas que han obtenido un certificado de
          competencia emitido por el CONOCER y respaldado por los propios
          empresarios y trabajadores de los distintos sectores del país.
        </p>
      </div>
    </div>

    <div class="row">
      <div class="container">
        <div class="col-sm-1">
          <br />
          &nbsp;
          <span
            ><img src="./assets/images/icon/lupa.png" class="iconLupa"
          /></span>
        </div>
        <div class="col-sm-12">
          <mat-form-field appearance="standard">
            <mat-label> CURP / Folio</mat-label>
            <input
              matInput
              (keyup.enter)="applyFilter(input.value)"
              #input
              oninput="this.value = this.value.toUpperCase()"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
    <br />
    <div>
      <div class="col-sm-offset-3 col-sm-9">
        <button class="btn btn-primary pull-right" type="submit" (click)="applyFilter(input.value)">Buscar</button>
      </div>
    </div>
    <div style="height:80px"></div>
    <!-- Eliminar boton Exportar a Excel  
    <div class="row">
      <div class="container">
        <div class="col-sm-3">
          <button mat-raised-button [disabled]="competences.length === 0" (click)="downloads()">
            Exportar a Excel
          </button>
        </div>
      </div>
    </div>
    <br /> -->

    <div class="row">
      <div class="container">
        <div class="col-sm-12 example-container">
          <div class="mat-elevation-z8">
            <table
              mat-table
              [dataSource]="dataSource"
              matTableExporter
              #exporter="matTableExporter"
              class="table table-striped table-bordered"
            >
              <ng-container matColumnDef="nombreCurso">
                <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                  Folio
                </th>
                <td mat-cell *matCellDef="let element" class="letraE">
                  {{ element.folio }}
                </td>
              </ng-container>

              <ng-container matColumnDef="capacitador">
                <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                  Tipo
                </th>
                <td mat-cell *matCellDef="let element" class="letraE">
                  {{ element.tipoCertificado }}
                </td>
              </ng-container>

              <ng-container matColumnDef="estandar">
                <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                  Código
                </th>
                <td mat-cell *matCellDef="let element" class="letraE">
                  {{ element.codigo }}
                </td>
              </ng-container>
              <ng-container matColumnDef="estado">
                <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                  Título
                </th>
                <td mat-cell *matCellDef="let element" class="letraE">
                  {{ element.normaEstandar }}
                </td>
              </ng-container>

              <ng-container matColumnDef="modalidad">
                <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                  Entidad de certificacion y Evaluacion
                </th>
                <td mat-cell *matCellDef="let element" class="letraE">
                  {{ element.certificador }}
                </td>
              </ng-container>

              <ng-container matColumnDef="modalidad2">
                <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                  Siglas
                </th>
                <td mat-cell *matCellDef="let element" class="letraE">
                  {{ element.siglasCertificador }}
                </td>
              </ng-container>

              <ng-container matColumnDef="modalidad3">
                <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                  Evaluador Centro de evaluación
                </th>
                <td mat-cell *matCellDef="let element" class="letraE">
                  {{ element.evaluador }}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>

            <div *ngIf="activeEror" class="no-data">
              <p>No se encontraron registros</p>
            </div>

            <br />
          </div>
        </div>
      </div>
    </div>

    <mat-paginator
      [length]="totalElements"
      [pageSize]="pageSize"
      showFirstLastButtons
    >
    </mat-paginator>
  </div>

</ng-container>
